module.exports = __webpack_public_path__ + "static/media/water-fire-theft-icon.938c6870.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/water-fire-theft-icon.png
// module id = 1273
// module chunks = 0